/* tslint:disable */
/* eslint-disable */

/**
 * 0 = BookedIn
 * 
 * 1 = InCalibration
 * 
 * 2 = CalReportComplete
 * 
 * 3 = AwaitingClientResponse
 * 
 * 4 = AwaitingRepair
 * 
 * 5 = Completed
 * 
 * 6 = Dispatched
 * 
 * 7 = ReadyForDispatch
 * 
 * 8 = SalesToProductionHandover
 * 
 * 9 = GenericInspectionThirdParty
 */
export enum Status {
  BookedIn = 0,
  InCalibration = 1,
  CalReportComplete = 2,
  AwaitingClientResponse = 3,
  AwaitingRepair = 4,
  Completed = 5,
  Dispatched = 6,
  ReadyForDispatch = 7,
  SalesToProductionHandover = 8,
  GenericInspectionThirdParty = 9
}
